module.exports = __webpack_public_path__ + "static/media/NeoSans.492ad7d3.ttf";